import { useRef } from "react";
import useOnScreen from "hooks/useIsOnScreen";
import { BadgeThemeProps } from "hardcover-ui/theme/components/badge";
import MatchPercentageBadge from "./MatchPercentageBadge";
import useBookMatchScore from "hooks/useBookMatchScore";

interface BookMatchPercentageForUserType {
  bookId: number;
  size?: BadgeThemeProps["size"];
}

export default function BookMatchPercentageForUser({
  bookId,
  size = "sm",
}: BookMatchPercentageForUserType) {
  const ref = useRef(null);
  const isVisible = useOnScreen(ref, "200px");
  const score = useBookMatchScore({bookId, isVisible});

  // No score available
  if (score === null) {
    return <></>;
  }

  // Loading the score
  if (score === undefined) {
    return <span ref={ref} className="invisible" />;
  }

  return <MatchPercentageBadge size={size} matchScore={score} />;
}
